// @ts-nocheck
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
/* Store Custom Code - End */

export const priceStyles = () => css`
    line-height: ${x => x.theme.design.typography.lineHeight.small};
    /* Store Custom Code - Start */
    color: ${getColor("common.accentContrast")};
    font-size: ${x => x.theme.design.typography.size.large};
    /* Store Custom Code - End */
`;

export const priceUnitOfMeasureStyles = () => css`
    position: relative;
    top: ${pxToRem(-1)};

    ${({ theme }) => css`
        font-size: ${theme.design.typography.size.smallest};
        font-weight: ${theme.design.typography.weight.base};
        line-height: ${theme.design.typography.lineHeight.semi};
    `}
`;

export const priceSecondarySpacingStyles = () => css`
    ${spacingStyles(pxToRem(3), null)}
`;

export const priceVatLabelStyles = () => css`
    ${({ theme }) => css`
        display: block;
        font-size: ${theme.design.typography.size.tiny};
        font-weight: ${theme.design.typography.weight.bold};
        line-height: ${theme.design.typography.lineHeight.semi};
    `}
`;
